<template>
  <PublicPopup ref="DownloadPopupRef" v-bind="popupConfig" close-on-click-overlay @close="installPromptCloseFun">
    <template #content>
      <Index52000 v-if="templateType === 'Index52000'" @install="triggerInstallDebounce" @close="handleTemplateClose" />
      <Index50000 v-else @install="triggerInstallDebounce" />
    </template>
  </PublicPopup>
</template>

<script setup>
import { useDevice } from '@/utils/useDevice'
import { debounce } from '@/utils/debounce'
import Index50000 from './DownloadPopup/template/index_50000.vue'
import Index52000 from './DownloadPopup/template/index_52000.vue'
import { getDownloadPopupTemplateType } from './DownloadPopup/template/js/index.js'

const DownloadPopupRef = ref(null)
const installPrompt = ref(null)

const emit = defineEmits(['close', 'download-guide'])

const templateType = computed(() => getDownloadPopupTemplateType())

const overlayStyle = {
  background: 'rgba(0, 0, 0, 0.65)',
}

const popupConfig = computed(() => {
  if (templateType.value === 'Index52000') {
    return {
      type: 'fullScreen',
      position: 'bottom',
      height: '320px',
      padding: 0,
      closeable: false,
      closeOnClickOverlay: false,
      overlayStyle,
    }
  }

  return {
    type: 'close',
    position: 'center',
    height: 100,
    padding: 10,
    closeable: true,
    closeOnClickOverlay: false,
    overlayStyle: null,
  }
})

const open = () => {
  if (window.deferredPrompt) {
    installPrompt.value = window.deferredPrompt
  }
  nextTick(() => {
    DownloadPopupRef.value?.open()
  })
}

const installPromptCloseFun = () => {
  emit('close')
  installPrompt.value = null
}

const handleTemplateClose = () => {
  DownloadPopupRef.value?.close()
}

onUnmounted(() => {
  installPrompt.value = null
})

const { isIOS } = useDevice()
function triggerInstall() {
  if (isIOS.value) {
    handleTemplateClose()
    emit('download-guide')
  } else {
    if (installPrompt.value) {
      installPrompt.value.prompt()

      installPrompt.value.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('用户同意安装')
        } else {
          console.log('用户拒绝安装')
        }

        installPrompt.value = null
        nextTick(() => {
          DownloadPopupRef.value?.close()
        })
      })
    } else {
      console.log('没用安装提示..需要补充安卓的引导页')
      handleTemplateClose()
      emit('download-guide')
    }
  }
}

const triggerInstallDebounce = debounce(triggerInstall)

defineExpose({ open })
</script>
